module.exports = __webpack_public_path__ + "static/media/hubspotPlug2x.10b844ef.png";